import MotivationalQuotesUtil from '../utils/MotivationalQuotesUtil'
import {FC, useEffect, useState} from 'react'
import { Button, Modal } from 'antd'
import { WordList } from '../../shared/types/api'
import Pages from '../../const/Pages'
import useFillGapsRepeatCardLists from '../../hooks/useFillGapsRepeatCardLists'
import { goToExercisePageWithReloading } from '../utils/goToPage'
import { NavigationPages } from '../../common/navigation/navigation-pages'
import { useNavigate } from 'react-router-dom'
import RepeatSuggestion from "../blocks/repeat-suggestion/RepeatSuggestion";
import TreeWatering from "../blocks/tree-watering/TreeWatering";
import CardImageUtils from "../utils/CardImageUtils";
import Constants from "../../const/Constants";
import {updateWordListRoutine} from "../../store/wordLists";
import {useAppDispatch} from "../../store/hooks";

interface CompletedExerciseDialogProps {
    selectedWordList: WordList | undefined;
    close: () => void;
    open: boolean
}

const FillGapsCompletedExerciseDialog: FC<CompletedExerciseDialogProps> = ({
                                                                               selectedWordList,
                                                                               close,
                                                                               open
                                                                           }) => {

    const deadImage = CardImageUtils.getCardImage(selectedWordList?.tree);
    const wateredImage = CardImageUtils.getCardWateredImage(selectedWordList?.tree);

    const [currentImage, setCurrentImage] = useState(deadImage);
    const [watering, setWatering] = useState(false);
    const [quote, setQuote] = useState<string>('');

    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const { repeatSuggestion, isLoading } = useFillGapsRepeatCardLists(Pages.FILL_GAPS, open, selectedWordList?.id)

    useEffect(() => {
        if (!open) return;
        setQuote(MotivationalQuotesUtil.generateRandomMotivationQuote());
        setCurrentImage(deadImage);
        setWatering(true);

        const timer = setTimeout(() => {
            setCurrentImage(wateredImage);
            setWatering(false);
        }, 1200);

        return () => clearTimeout(timer);
    }, [open]);

    const updateTreeStatus = (
        wordList: WordList | undefined,
        status: string
    ): WordList | undefined => {
        if (!wordList || !wordList.tree) return wordList;

        return {
            ...wordList,
            tree: {
                ...wordList.tree,
                status
            }
        };
    };

    const clearAndClose = () => {
        setTimeout(() => {
            const wordList = updateTreeStatus(selectedWordList, Constants.TREE_STATUSES[0])
            dispatch(updateWordListRoutine(wordList))
        }, 500);
        close()
    }

    const openSuggestionList = (rs: WordList) => {
        clearAndClose()
        goToExercisePageWithReloading(NavigationPages.GUESS_WORD, navigate, rs)
    }

    return (
        <Modal
            title={'Молодец! Все карточки в списке пройдены!'}
            onCancel={clearAndClose}
            footer={[
                <Button danger onClick={clearAndClose}>
                    Закрыть
                </Button>
            ]}
            open={open}>
            <div>
                <span>{MotivationalQuotesUtil.generateRandomMotivationQuote()}</span>
            </div>
            <TreeWatering selectedWordList={selectedWordList}
                          currentImage={currentImage}
                          watering={watering}/>
            <RepeatSuggestion isLoading={isLoading} repeatSuggestion={repeatSuggestion}
                              openSuggestionList={openSuggestionList}
                              clearAndClose={clearAndClose}/>
        </Modal>
    )
}

export default FillGapsCompletedExerciseDialog